import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // Phase 60: Obsidian Primary (Default)
        default:
          "bg-slate-900 text-white shadow-sm hover:bg-slate-800",
        // Phase 60: Destructive/Danger
        destructive:
          "bg-red-600 text-white shadow-sm hover:bg-red-700",
        // Phase 60: Slate Outline Secondary
        outline:
          "border border-slate-300 bg-white text-slate-700 shadow-sm hover:bg-slate-50 hover:border-slate-400",
        // Phase 60: Subtle Secondary
        secondary:
          "bg-slate-100 text-slate-700 shadow-sm hover:bg-slate-200",
        // Phase 60: Ghost
        ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
        // Phase 60: Link
        link: "text-slate-900 underline-offset-4 hover:underline",
        // Phase 60: New - Institutional Primary (explicit)
        institutional:
          "bg-slate-900 text-white shadow-sm hover:bg-slate-800 border border-slate-900",
        // Phase 60: New - Institutional Secondary
        "institutional-secondary":
          "bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 hover:border-slate-400",
        // Phase 60: New - Success (for data actions)
        success:
          "bg-emerald-600 text-white shadow-sm hover:bg-emerald-700",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
